import { axiosStudentInstance } from "./studentAuth"
import type { StudentApiEnvelope } from "./studentQuestions"
import type { PracticePaperSession } from "./studentPracticePapers"

export interface SitAnswerPatch {
  questionId: string
  answerText?: string
  timeSpentSeconds?: number
  status?: "unanswered" | "answered"
}

export interface SitSavePayload {
  sitToken: string
  revision: number
  currentQuestionIndex?: number
  totalTimeSpentSeconds?: number
  answers?: SitAnswerPatch[]
  idempotencyKey?: string
}

export interface SitTokenPayload {
  sitToken?: string
  revision?: number
  currentQuestionIndex?: number
  totalTimeSpentSeconds?: number
  answers?: SitAnswerPatch[]
  idempotencyKey?: string
}

type SitEnvelope = StudentApiEnvelope<PracticePaperSession>

const sitHeaders = (sitToken?: string | null) =>
  sitToken ? { "X-Sit-Token": sitToken } : undefined

export const startSitSession = (paperId: string) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/start/`
  )

export const resumeSitSession = (paperId: string) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/resume/`
  )

export const getSitSession = (paperId: string, sitToken?: string | null) =>
  axiosStudentInstance.get<SitEnvelope>(`/practice-papers/${paperId}/sit/`, {
    headers: sitHeaders(sitToken),
  })

export const saveSitProgress = (paperId: string, payload: SitSavePayload) =>
  axiosStudentInstance.patch<SitEnvelope>(
    `/practice-papers/${paperId}/sit/save/`,
    payload,
    { headers: sitHeaders(payload.sitToken) }
  )

export const exitSitSession = (paperId: string, payload: SitSavePayload) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/exit/`,
    payload,
    { headers: sitHeaders(payload.sitToken) }
  )

export const abandonSitSession = (paperId: string, payload: SitTokenPayload) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/abandon/`,
    payload,
    { headers: sitHeaders(payload.sitToken) }
  )

export const submitSitSession = (paperId: string, payload: SitTokenPayload) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/submit/`,
    payload,
    { headers: sitHeaders(payload.sitToken) }
  )

/** Reset answers on the same paper and open a new sit session. */
export const retakeSitSession = (paperId: string) =>
  axiosStudentInstance.post<SitEnvelope>(
    `/practice-papers/${paperId}/sit/retake/`
  )
